var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConfigTemplate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    fill: "none",
    viewBox: "0 0 192 192",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1D71B8",
    d: "m132 100 24 3V54l-30-30H66a6 6 0 0 0-6 6v18h42l30 30v22Z",
    opacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1D71B8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 12,
    d: "M95 168H42a6 6 0 0 1-6-6V54a6 6 0 0 1 6-6h60l30 30v19"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1D71B8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 12,
    d: "M60 48V30a6 6 0 0 1 6-6h60l30 30v48m-90 12h36m-36 24h16"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#1D71B8",
    d: "m174.258 143.729-7.842-4.432a22.84 22.84 0 0 0-1.908-3.355l.151-9.14a30.945 30.945 0 0 0-11.566-6.771l-7.691 4.678a26.4 26.4 0 0 0-3.815 0L133.865 120a31.37 31.37 0 0 0-11.536 6.802l.152 9.14a22.749 22.749 0 0 0-1.908 3.355l-7.873 4.432a32.396 32.396 0 0 0 .031 13.542l7.842 4.432a24.722 24.722 0 0 0 1.908 3.385l-.152 9.11a30.948 30.948 0 0 0 11.567 6.771l7.691-4.678a26.4 26.4 0 0 0 3.815 0l7.721 4.709a31.362 31.362 0 0 0 11.536-6.802l-.151-9.14a22.84 22.84 0 0 0 1.908-3.355l7.872-4.432a31.906 31.906 0 0 0-.03-13.542Zm-30.764 21.544c-2.874 0-5.684-.866-8.074-2.49a14.72 14.72 0 0 1-5.353-6.63 14.995 14.995 0 0 1-.827-8.535 14.846 14.846 0 0 1 3.977-7.564 14.467 14.467 0 0 1 7.442-4.043 14.308 14.308 0 0 1 8.397.841 14.583 14.583 0 0 1 6.523 5.441 14.943 14.943 0 0 1 2.449 8.207c0 3.918-1.531 7.676-4.257 10.446a14.412 14.412 0 0 1-10.277 4.327Z",
    opacity: 0.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1D71B8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6,
    d: "M143.5 165c8.008 0 14.5-6.492 14.5-14.5s-6.492-14.5-14.5-14.5-14.5 6.492-14.5 14.5 6.492 14.5 14.5 14.5Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1D71B8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6,
    d: "M164.508 135.942a22.84 22.84 0 0 1 1.908 3.355l7.842 4.432c.979 4.458.989 9.079.03 13.542l-7.872 4.432a22.84 22.84 0 0 1-1.908 3.355l.151 9.14A31.362 31.362 0 0 1 153.123 181l-7.721-4.709a26.4 26.4 0 0 1-3.815 0l-7.691 4.678a30.948 30.948 0 0 1-11.567-6.771l.152-9.11a24.722 24.722 0 0 1-1.908-3.385l-7.842-4.432a32.396 32.396 0 0 1-.031-13.542l7.873-4.432a22.749 22.749 0 0 1 1.908-3.355l-.152-9.14A31.37 31.37 0 0 1 133.865 120l7.722 4.709a26.4 26.4 0 0 1 3.815 0l7.691-4.678a30.945 30.945 0 0 1 11.566 6.771l-.151 9.14Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfigTemplate);
export default __webpack_public_path__ + "static/media/ConfigTemplate.66d90f6b522d8d74a1d40e34f94cb20e.svg";
export { ForwardRef as ReactComponent };